"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const PublishingServicesAvatar = () => /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 37 43"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: "#008cff",
  d: "M18.58 20.81L0 29.89V9.3L18.58 0l18.45 9.23v20.66l-18.45-9.08zm-4.12 14.13h8.12v8.12h-8.12z"
}));

var _default = PublishingServicesAvatar;
exports.default = _default;